import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';
import '../../assets/css/common.css';
import UserSidebar from './UserSidebar';
import { useParams } from 'react-router-dom';
import { openAlert } from '../../utils/common';
import userService from '../../services/userService';

const UserDetailLayout = () => {
  const [profile, setProfile] = useState({});
  const {userIdx} = useParams();
  const menuItems = [
      { to: `/user/profile/${userIdx}`, label: '회원정보' },
      { to: `/user/gluco/${userIdx}`, label: '혈당수치 조회' },
      { to: `/user/report/${userIdx}`, label: '보고서 작성 관리' },
      { to: `/user/fingerprint/${userIdx}`, label: '지문 관리' },
      { to: `/user/ai-model/${userIdx}`, label: '보정 처리 (이동)' },
    ];

  useEffect(() => {
    const fetchProfile = async (idxArg) => {
        try{
            const result = await userService.getUserName(idxArg);

            if(!result.success) {
                openAlert({ title: '알림', description: result.message });
                return;
            }
            if(!result.data?.userName) {
                openAlert({ title: '알림', description: '올바른 접근이 아닙니다.'});
                return;
            }
            setProfile(result.data);
        }catch(e){
            console.error(e);
            openAlert({ title: '알림', description: '데이터 로드 중 오류가 발생했습니다.' });
        }
    }
    fetchProfile(userIdx);
  }, [userIdx]);

/*const handleLoad = useCallback((profile) => {
    setProfile(profile);
  }, []);
  const outletContext = useMemo(() => ({ handleLoad }), [handleLoad]);
*/

  return (
    <div className="wrap popup_info">
      <div className="section_area">
        <UserSidebar items={menuItems} username={profile?.userName}/>
        <div className="section_wrap">
          <Outlet/>
        </div>
      </div>
    </div>
  );
};

export default UserDetailLayout;
